import _ from 'lodash';
import { call, put, takeLatest, takeLeading, takeEvery } from 'redux-saga/effects';
import { apiServiceAsync } from '../../services/apiService';
import { actions, ActionTypes } from './modules';
import { actionTypes as recruitmentProfileActionTypes } from '../../recruitmentProfiles/modules';

const { loadProfilesSuccess, loadProfilesFailure, loadApplicationProfilesSuccess, loadApplicationProfilesFail } =
  actions;

/*
 * Fetches all of a user's profiles
 */
function* loadRecruitmentProfilesSaga(): any {
  try {
    const { profiles } = yield call(apiServiceAsync.getOwnRecruitmentProfiles);
    yield put(loadProfilesSuccess(profiles || []));
  } catch (e) {
    yield put(loadProfilesFailure());
  }
}

/*
 * Fetches all of a users profiles that meet the requirements of a particular profile
 */
function* loadApplicationProfilesSaga(action: any): any {
  const [targetProfileId] = _.keys(action.payload);

  try {
    const { requirementsChecks } = yield call(apiServiceAsync.getProfilesForApplication, targetProfileId);

    yield put(loadApplicationProfilesSuccess(requirementsChecks || [], targetProfileId));
  } catch (e) {
    yield put(loadApplicationProfilesFail());
  }
}

export function* watchLoadOwnProfiles(): any {
  // Use takeLeading for initial load - only process the first request,
  // ignore duplicates while loading (prevents multiple API calls on mount)
  yield takeLeading(ActionTypes.LOAD_RECRUITMENT_PROFILES, loadRecruitmentProfilesSaga);
}

export function* watchRefreshOwnProfilesAfterMutation(): any {
  // Use takeLatest for post-mutation refetch - we want the freshest data
  yield takeLatest(
    [recruitmentProfileActionTypes.CREATE_PROFILE_SUCCESS, recruitmentProfileActionTypes.SAVE_PROFILE_SUCCESS],
    loadRecruitmentProfilesSaga
  );
}

export function* watchLoadApplicationProfiles(): any {
  yield takeEvery(ActionTypes.REQUEST_PROFILES_FOR_APPLICATION, loadApplicationProfilesSaga);
}

// Export saga FUNCTIONS, not pre-called generators
export const sharedRecruitmentSagaFunctions = [
  watchLoadOwnProfiles,
  watchRefreshOwnProfilesAfterMutation,
  watchLoadApplicationProfiles
];

export default [watchLoadOwnProfiles(), watchRefreshOwnProfilesAfterMutation(), watchLoadApplicationProfiles()];
